import React from 'react';

function ArrowLeftIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M20,10c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2H2.8l6.1,5.9C9,16.8,9.1,16.9,9.1,17c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3C8.8,18,8.8,18,8.7,18.1c-0.1,0-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2l-7.5-7.3c-0.1-0.1-0.1-0.2-0.2-0.3C0,10.2,0,10.1,0,10s0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3l7.5-7.3C7.9,2,8.1,1.9,8.3,1.9c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6S9.1,3.1,8.9,3.3L2.8,9.2h16.3c0.2,0,0.4,0.1,0.6,0.2C19.9,9.6,20,9.8,20,10z"/>
    </svg>
  );
}

export default ArrowLeftIcon;
